import React from "react";
import { LatestOnCoinContainer } from "./style";
import type { PostPropType } from "types/blog-type";
import BlogPost from "../BlogRedesign/BlogPost";
import { useTranslations } from "i18n";
import { Colors } from "themes/color-palette";
import { FontWeight, HubbleDisplay } from "components/parts/Typography";
import { Flex } from "@hubble/web";

interface LatestOnCoinComponentProps {
  coinName: string;
  posts: PostPropType[];
  isMobile?: boolean;
}

const LatestOnCoin = (props: LatestOnCoinComponentProps) => {
  const { coinName, posts, isMobile } = props;
  const t = useTranslations("how-to-buy");

  if (!posts || posts.length === 0) {
    return null;
  }

  const renderBlogPosts = (isBlogPost: boolean) => {
    return posts
      .filter((post) => Boolean(post.articleType) === isBlogPost)
      .map((post) => (
        <BlogPost
          key={post.id}
          post={post}
          displayIntro={!post.articleType}
          displayAuthorDetails={true}
          authorDetailsStyles={{
            position: "static",
            marginTop: "0.5rem",
            textAlign: "left"
          }}
          postMetaDetailsPosition="bottom"
          containerStyles={{
            paddingBottom: "0",
            maxWidth: "310px",
            height: "410px"
          }}
          openPostInNewTab={true}
          postMetaDetailsContainerStyles={{
            flexDirection: "column",
            alignItems: "flex-start",
            marginTop: "1rem"
          }}
          titleStyles={{
            ...(!isBlogPost ? { WebkitLineClamp: 2 } : {}),
            maxWidth: "100%"
          }}
        />
      ));
  };

  return (
    <LatestOnCoinContainer>
      <HubbleDisplay
        as="h2"
        size="lg"
        color={Colors.gray[600]}
        align="center"
        fontWeight={parseInt(FontWeight.bold)}
        mb={isMobile ? 3 : 6}
      >
        {t("latestOnCoin")} {coinName}
      </HubbleDisplay>
      <Flex gap={"16px"} justify="center" align="center" flexWrap="wrap" mb={4}>
        {renderBlogPosts(true)}
      </Flex>
      <Flex gap={"16px"} justify="center" align="center" flexWrap="wrap">
        {renderBlogPosts(false)}
      </Flex>
    </LatestOnCoinContainer>
  );
};

export default LatestOnCoin;
